import { fromJcamp } from 'nmr-metadata';
import { findBy, getExtension, getReference, getTargetProperty, getTextContent, } from "../common.js";
const isFid = /[^a-z]fid[^a-z]/i;
const replaceFid = /[^a-z]fid[^a-z]?/i;
const nmr = {
    find: findBy(getNmrReference),
    getProperty: (filename) => {
        const extension = getExtension(filename);
        if ((extension === 'jdx' || extension === 'dx' || extension === 'jcamp') &&
            isFid.test(filename)) {
            return 'jcampFID';
        }
        return getTargetProperty(filename);
    },
    process: (filename, content) => {
        const extension = getExtension(filename);
        let metaData = {};
        if (extension === 'jdx' || extension === 'dx' || extension === 'jcamp') {
            const textContent = getTextContent(content);
            metaData = fromJcamp(textContent);
        }
        return metaData;
    },
    jpath: ['spectra', 'nmr'],
};
export default nmr;
/**
 * An experiment is delivered as a FID and its Fourier transform, so the `fid`
 * marker is not part of its identity.
 * @param filename - The file path.
 * @returns The reference string.
 */
function getNmrReference(filename) {
    const reference = getReference(filename);
    if (isFid.test(filename)) {
        return reference.replace(replaceFid, '');
    }
    return reference;
}
//# sourceMappingURL=nmr.js.map